import { Outlet } from 'react-router';
import { Sidebar } from './Sidebar';
import { Header } from './Header';

export function AppShell() {
  return (
    <div className="min-h-screen bg-surface-dark">
      <Sidebar />
      <Header />
      <main className="ms-60 mt-14 p-6">
        <Outlet />
      </main>
    </div>
  );
}
